import { render, staticRenderFns } from "./user_deparment.vue?vue&type=template&id=cbb72db6&scoped=true"
import script from "./user_deparment.vue?vue&type=script&lang=js"
export * from "./user_deparment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb72db6",
  null
  
)

export default component.exports